import { useEffect } from "react";
import { isDevlopment } from "../env";

export const usePreventCopyPaste = () => {
  useEffect(() => {
    const handleContextMenu = (e: MouseEvent) => {
      if (isDevlopment()) {
        return;
      }

      e.preventDefault();
    };
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.ctrlKey && ["KeyC", "KeyV", "KeyP"].includes(e.code)) {
        if (isDevlopment()) {
          return;
        }
        e.preventDefault();
      }
    };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
};
